import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "#app/components/auth/auth-layout";
import { AcceptInviteForm } from "#app/components/auth/accept-invite-form";
import { SignedInAcceptInvite } from "#app/components/auth/signed-in-accept-invite";
import { useAuth } from "#app/lib/auth-context";

function AcceptInviteScreen() {
  const { state } = useAuth();
  // A signed-in invitee never needs a password: the token names the
  // workspace, their membership row already exists, so the link opens the
  // same Join / Decline screen the app gates on. Signed out (or the session
  // still resolving) keeps the credentials form.
  if (state.isAuthenticated) {
    return <SignedInAcceptInvite />;
  }
  return (
    <AuthLayout
      heading="Accept Invitation"
      legalAction="accepting an invitation"
      subheading="Set your name and password to finish setting up your account."
      footerText="Already have an account?"
      footerLinkText="Log in"
      footerLinkHref="/login"
    >
      <AcceptInviteForm />
    </AuthLayout>
  );
}

export const Route = createFileRoute("/(auth)/accept-invite")({
  component: AcceptInviteScreen,
  // The root navigator bounces signed-in users off (auth) screens; the
  // emailed link must survive that so it can route them by their session.
  staticData: { allowAuthenticated: true },
});
